// Who last saved a revision, and when. Written next to that revision's data on
// every save (PV, Piping, Structural) and read back by the module headers to
// show a "saved by / saved at" line under the Rev. picker.
//
// Stored as plain fields on the revision payload rather than a nested object:
// revisions saved before this existed simply carry none of them and read back
// as "no stamp", which is what readRevisionSaveStamp returns.

export const buildRevisionSaveStamp = (user) => ({
  savedBy: String(user?.name || user?.email || "").trim(),
  savedById: user?.id || "",
  savedAt: new Date().toISOString(),
});

export const readRevisionSaveStamp = (source) => {
  if (!source || typeof source !== "object") return null;

  const savedBy = String(source.savedBy ?? "").trim();
  const savedAt = String(source.savedAt ?? "").trim();

  if (!savedBy && !savedAt) return null;

  return { savedBy, savedAt, savedById: source.savedById || "" };
};

export const formatRevisionSaveDate = (savedAt) => {
  if (!savedAt) return "";

  const date = new Date(savedAt);
  if (isNaN(date.getTime())) return String(savedAt);

  // Date only - the time of day isn't wanted in the header.
  return date.toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  });
};

// Branching a revision copies its data into the new one - but not who saved
// the old one. A revision nobody has saved yet must show no stamp at all.
export const stripRevisionSaveStamp = (revisionData) => {
  if (!revisionData || typeof revisionData !== "object") return revisionData;

  const { savedBy, savedById, savedAt, ...rest } = revisionData;
  return rest;
};
